import { takeEvery } from 'redux-saga/effects';

import * as paymentMethodsActionTypes from 'store/modules/paymentMethods/actionTypes';
import { create } from './utils';

export default function* listenCreate() {
  yield takeEvery(paymentMethodsActionTypes.CREATE, create);
}
